/**
 * @flow
 * @relayHash 4e98375d8051b91c400bdd5678b444b3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SubmitSurveyInput = {|
  leadType?: ?string,
  uiLang?: ?string,
  relatedIds?: ?$ReadOnlyArray<?string>,
  answer?: ?SubmitSurveyAnswer,
  inquiryContents?: ?string,
  catalogDownloadPage?: ?CatalogDownloadPageInput,
  aperzaUser?: ?AperzaUserInput,
  clientMutationId?: ?string,
|};
export type SubmitSurveyAnswer = {|
  id?: ?number,
  answers?: ?$ReadOnlyArray<?SubmitSurveyItemAnswer>,
|};
export type SubmitSurveyItemAnswer = {|
  id?: ?number,
  answerId?: ?number,
|};
export type CatalogDownloadPageInput = {|
  pageType?: ?string,
  pageId?: ?string,
|};
export type AperzaUserInput = {|
  id?: ?string,
  lastName?: ?string,
  firstName?: ?string,
  phoneNumber?: ?string,
  companyName?: ?string,
  officeName?: ?string,
  departmentName?: ?string,
  businessType?: ?string,
  jobCategoryType?: ?string,
  subdivisionCode?: ?string,
|};
export type SubmitSurveyMutationVariables = {|
  input: SubmitSurveyInput
|};
export type SubmitSurveyMutationResponse = {|
  +submitSurvey: ?{|
    +clientMutationId: ?string
  |}
|};
export type SubmitSurveyMutation = {|
  variables: SubmitSurveyMutationVariables,
  response: SubmitSurveyMutationResponse,
|};
*/


/*
mutation SubmitSurveyMutation(
  $input: SubmitSurveyInput!
) {
  submitSurvey(input: $input) {
    clientMutationId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SubmitSurveyInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "submitSurvey",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SubmitSurveyPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SubmitSurveyMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SubmitSurveyMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "SubmitSurveyMutation",
    "id": null,
    "text": "mutation SubmitSurveyMutation(\n  $input: SubmitSurveyInput!\n) {\n  submitSurvey(input: $input) {\n    clientMutationId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c104636f0f52bc3fdaf5d6a2bab8e06b';
module.exports = node;
